/**
 * 메뉴 디자이너 사이드바(AI Bot 좌측 메뉴) ↔ 디자이너 화면 브리지.
 *
 * 챗봇은 전역 컴포넌트라 디자이너 화면의 상태를 직접 볼 수 없다. 디자이너 탭이
 * 마운트되며 실행기를 여기 등록하면, 챗봇 사이드바는 "등록된 실행기가 있는가"만 보고
 * 버튼을 활성화한다. (챗봇이 특정 메뉴 모듈을 직접 import하지 않게 해
 * 의존 방향을 한쪽으로 유지한다)
 *
 * snotes-ai(aiStudio) 전환 후에는 임시저장·배포·쿼리 설정을 모두 Agent가 Tool로 처리하므로
 * 버튼이 필요한 기능은 '새 채팅' 하나뿐이다. 나머지는 챗봇에 자연어로 말하면 된다
 * (예: "임시저장해줘", "배포해줘").
 */
import { create } from "zustand";

export interface StudioAiActions {
  /** 새 채팅 — 진행 중인 대화와 편집 중인 화면을 모두 비운다 */
  newChat: () => void;
}

interface StudioAiActionsState {
  /** 디자이너 탭이 열려 있을 때만 세팅된다(없으면 사이드바 버튼이 비활성). */
  actions: StudioAiActions | null;
  setActions: (actions: StudioAiActions | null) => void;
}

export const studioAiActions = create<StudioAiActionsState>((set) => ({
  actions: null,
  setActions: (actions) => set({ actions }),
}));
